import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { UserProfiles } from '../../../Models/user-profiles.model';
import { UserManagementService } from '../../../Services/user-management/user-management.service';
import { PowerUserRoles } from '../../../Models/user-profiles.model';
import { Router } from '@angular/router';
import { SessionService } from '../../../Services/session.service';
import * as $ from 'jquery';
declare const sort: any;

export interface IPowerUserListData {
  Power_User_ID: string
  Full_Name: string
  Email_Address: string
  Power_User_Status_Type_Code: string
  Power_User_Status_Type_Name: string
  Primary_Phone_Country_Code: string
  Primary_Phone_Number: string
  Education_Type_Code: string
  Education_Type_Name: string
  Experience_Type_Code: string
  Experience_Type_Name: string
  Created_By: string
  Creation_Date: string
  Activate_Role_Assign_Ind: string
}

@Component({
  selector: 'app-power-user-list',
  templateUrl: './power-user-list.component.html',
  styleUrls: ['./power-user-list.component.css'],
  encapsulation: ViewEncapsulation.Emulated
})
export class PowerUserListComponent implements OnInit {
  powerUsers: UserProfiles[] = [];
  // user_profile_data: any = undefined;
  Power_User_Role_Data: PowerUserRoles[] = [];
  dataSource: any;
  PowerUserSource: any;

  constructor(
    private sessionService: SessionService,
    private router: Router,
    public userService: UserManagementService
  ) {

    const payload = {
      PowerUserID: null,
      EmailAddressOnly: null,
      NameOnly:  null,
      SubjectID: null,
    };
    this.userService.getPowerUsers(payload).subscribe(
      (res:any) => {
        
        this.getUsersResponse(res?.PowerUserList ??[]);
      },
      (error) => {
        console.log(error);
      }
    );
    const requestBody = {
      PowerUserRoleID: null,
      SubjectID: null,
      PowerUserID: null
    };
    this.userService.getUserRoleList(requestBody).subscribe(
      (res:any) => {
        console.log(res?.PowerUserRoleList[0],"REsponsed");
        
        this.getUserRoleResponse(res?.PowerUserRoleList);
      },
      (error) => {
        console.log(error);
      }
    );
  }
  //  title = 'datatables';
  //  dtOptions: DataTables.Settings = {};
  //  posts;

  ngOnInit(): void {}

  getUsersResponse(data: IPowerUserListData[]) {
    const tempUsers: UserProfiles[] = [];
  
    data.forEach((element) => {
      const fullName = element.Full_Name || '';
      const nameParts = fullName.split(' ');
      const firstName = nameParts[0] || '';
      const lastName = nameParts[1] || '';
  
      tempUsers.push({
        powerUser: element.Power_User_ID,
        firstName: firstName,
        lastName: lastName,
        middleName: '',
        name: fullName,
        status: element.Power_User_Status_Type_Code,
        primaryPhoneNumber: element.Primary_Phone_Number,
        emailAddress: element.Email_Address,
        education: element.Education_Type_Code,
        experience: element.Experience_Type_Code,
        createDate: element.Creation_Date,
        createdBy: element.Created_By,
        secondaryphoneNumber: '',
        primaryPhoneCountry: element.Primary_Phone_Country_Code,
        secondaryPhoneCountry: '',
        AddressLine1: '',
        AddressLine2: '',
        PostalCode: '',
        StateCode: '',
        CityName: '',
        CountryCode: '',
      });
    });
  
    this.powerUsers = tempUsers;
    this.dataSource = this.powerUsers;
  }
  

  getUserRoleResponse(data: any) {
    var tempUserRole: PowerUserRoles[] = [];
    //console.log(data)

    data.forEach(
      (element: {
        Role_Updatable_Ind: string;
        Power_User_Role_Status_Type_Name: string;
        LoggedInUser: any;
        Power_User_Role_Id: any;
        Power_User_ID: any;
        Power_User_Role_Type_Name: any;
        Start_Date: any;
        End_Date: any;
        Comment_Text: any;
        StatusType: any;
        Subjects: any;
        Power_User_Name: any;
        PowerUserSubjectId: any;
        SubjectId: any;
        PrimarySubjectInd: any;
      }) => {
        tempUserRole.push({
          LoggedInUser: element.LoggedInUser,
          PowerUserRoleId: element.Power_User_Role_Id,
          PowerUserId: element.Power_User_ID,
          PowerUserRoleType: element.Power_User_Role_Type_Name,
          StartDate: element.Start_Date,
          EndDate: element.End_Date,
          Comment: element.Comment_Text,
          StatusType: element.Power_User_Role_Status_Type_Name,
          Subjects: element.Subjects,
          name: element.Power_User_Name,
          Power_User_Role_Status_Type_Name:
            element.Power_User_Role_Status_Type_Name,
          Role_Updatable_Ind: element.Role_Updatable_Ind,
          SubjectList: [
            {
              PowerUserSubjectId: element.PowerUserSubjectId,
              PowerUserRoleId: element.Power_User_ID,
              SubjectId: element.SubjectId,
              PrimarySubjectInd: element.PrimarySubjectInd,
            },
            {
              PowerUserSubjectId: element.PowerUserSubjectId,
              PowerUserRoleId: element.Power_User_ID,
              SubjectId: element.SubjectId,
              PrimarySubjectInd: element.PrimarySubjectInd,
            },
            {
              PowerUserSubjectId: element.PowerUserSubjectId,
              PowerUserRoleId: element.Power_User_ID,
              SubjectId: element.SubjectId,
              PrimarySubjectInd: element.PrimarySubjectInd,
            },
          ],
        });
      }
    );

    this.Power_User_Role_Data = tempUserRole;
    this.PowerUserSource = this.Power_User_Role_Data;
  }

  OnClickAddButton() {
    this.router.navigate(['/powerUserRegistration']);
  }
  onClickUserListRow(element: any) {
    
    this.userService.powerUserId = element.powerUser;
    this.router.navigate(['/editPowerUser',element.powerUser]);
  }

  onClickUserRoleListRow(elem: {
    Role_Updatable_Ind: string;
    PowerUserRoleId: number;
    PowerUserId: string;
  }) {
    console.log(elem);
    this.userService.getCodes('POWER_USER_ROLE_TYPE').subscribe(
      (res) => {
        this.getStatusTypeResponse(res);
        this.userService.powerUserRoleID = elem.PowerUserRoleId;
        this.userService.powerUserId = elem.PowerUserId;
        this.userService.Power_User_Role_Ind = elem.Role_Updatable_Ind;
        this.userService.Screenurl = 'User/Poweruserlist';
        this.router.navigate([`/EditPowerUserRole/${elem.PowerUserId}/${elem.PowerUserRoleId}`]);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getStatusTypeResponse(data: any) {
    var tempRoleStatusType: any[] = [];

    data.forEach((element: { Code: any; Name: any }) => {
      tempRoleStatusType.push({
        Code: element.Code,
        Name: element.Name,
      });
    });

    this.userService.powerUserStatusTypes = tempRoleStatusType;
  }
}
